/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for DNS Policy factories.
 *
 * @author Abhinesh Gour
 */

/**
 * Dependency token for DnsInfoConfigItem.
 */
export const DNS_INFO_CONFIG_ITEM_TOKEN = 'DnsInfoConfigItem';

/**
 *  Dependency token for DNS Policy Collection.
 */
export const DNS_POLICY_COLLECTION_TOKEN = 'DnsPolicyCollection';

/**
 * Dependency token for DNS Policy item.
 */
export const DNS_POLICY_ITEM_TOKEN = 'DnsPolicyItem';

/**
 * Dependency token for DNS Policy Rule config item.
 */
export const DNS_RULE_CONFIG_ITEM_TOKEN = 'DnsRuleConfigItem';

/**
 * Dependency token for DNS Rule Match Target config item.
 */
export const DNS_RULE_MATCH_TARGET_CONFIG_ITEM_TOKEN = 'DnsRuleMatchTargetConfigItem';

/**
 * Dependency token for Dns ClientIp Matchconfig item.
 */
export const DNS_CLIENT_IP_MATCH_CONFIG_ITEM_TOKEN = 'DnsClientIpMatchConfigItem';

/**
 * Dependency token for Dns Geo Matchconfig item.
 */
export const DNS_GEO_LOCATION_MATCH_CONFIG_ITEM_TOKEN = 'DnsGeoLocationMatchConfigItem';

/**
 * Dependency token for Dns Client Port Matchconfig item.
 */
export const DNS_CLIENT_PORT_MATCH_CONFIG_ITEM_TOKEN = 'DnsClientPortMatchConfigItem';

/**
 * Dependency token for Dns Transport Protocol Matchconfig item.
 */
export const DNS_TRANSPORT_PROTOCOL_MATCH_CONFIG_ITEM_TOKEN = 'DnsTransportProtocolMatchConfigItem';

/**
 * Dependency token for Dns Query Name Matchconfig item.
 */
export const DNS_QUERY_NAME_MATCH_CONFIG_ITEM_TOKEN = 'DnsQueryNameMatchConfigItem';

/**
 * Dependency token for Dns Query Type Matchconfig item.
 */
export const DNS_QUERY_TYPE_MATCH_CONFIG_ITEM_TOKEN = 'DnsQueryTypeMatchConfigItem';

/**
 * Dependency token for Dns Rule Action config item.
 */
export const DNS_RULE_ACTION_CONFIG_ITEM_TOKEN = 'DnsRuleActionConfigItem';
